import { INeoAction } from './../Actions.interface';
import { EVENT_LIST_ACTIONS } from '../../Constants/Actions.constants';
import { isActionValid } from '../../Helpers/Reducer.helper';

const useValidActions = isActionValid([EVENT_LIST_ACTIONS.SELECT_EVENT]);

export default (state = {}, action: INeoAction) => {
  const { SELECT_EVENT, UNSELECT_EVENT } = EVENT_LIST_ACTIONS;

  const { name, payload } = action;

  const actionValid = useValidActions(name);

  if (actionValid) {
    if (name === SELECT_EVENT) {
      return {
        ...state,
        ...payload,
      };
    }

    if (name === UNSELECT_EVENT) {
      return {};
    }
  }
  return state;
};
